import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import GenerateDialog from "../components/GenerateDialog";
import { DataLabel } from "../components/common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { Flask, Sparkle, ArrowSquareOut, TrendUp } from "@phosphor-icons/react";

function scoreColor(s) { return s >= 80 ? "#166534" : s >= 60 ? "#0B3B2D" : s >= 40 ? "#b45309" : "#9CA3AF"; }

export default function ScientificWatch() {
  const [studies, setStudies] = useState([]);
  const [topics, setTopics] = useState([]);
  const [gen, setGen] = useState({});

  const load = async () => {
    const [s, t] = await Promise.all([api.get("/watch"), api.get("/topics?status=new")]);
    setStudies(s.data); setTopics(t.data);
  };
  useEffect(() => { load(); const i = setInterval(load, 10000); return () => clearInterval(i); }, []);

  const runWatch = async () => { await api.post("/agents/scientific_watch/run"); toast.success("Veille PubMed lancée"); };
  const dismiss = async (id) => { await api.post(`/topics/${id}/dismiss`); load(); };

  return (
    <div>
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-muted-foreground mb-1">Intelligence</div>
          <h1 className="font-serif text-4xl text-brand tracking-tight">Veille scientifique</h1>
        </div>
        <button data-testid="run-watch-btn" onClick={runWatch}
          className="flex items-center gap-2 border border-brand text-brand hover:bg-brand-soft px-4 py-2 rounded-md text-sm font-medium transition-colors">
          <Flask size={16} /> Lancer la veille PubMed
        </button>
      </div>

      <Tabs defaultValue="topics">
        <TabsList>
          <TabsTrigger value="topics" data-testid="tab-topics">Opportunités ({topics.length})</TabsTrigger>
          <TabsTrigger value="studies" data-testid="tab-studies">Publications ({studies.length})</TabsTrigger>
        </TabsList>

        <TabsContent value="topics" className="mt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {topics.length === 0 && <div className="text-sm text-muted-foreground col-span-2">Aucune opportunité en attente. Lancez la veille ou l'analyse des lacunes.</div>}
            {topics.map((t) => (
              <div key={t.id} data-testid={`topic-${t.id}`} className="bg-white border border-border rounded-md p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[10px] font-mono uppercase tracking-wider px-2 py-0.5 rounded bg-secondary text-muted-foreground">
                    {t.source === "scientific_watch" ? "Veille" : "Lacune"}</span>
                  <span className="flex items-center gap-1 text-xs font-mono" style={{ color: scoreColor(t.priority) }}>
                    <TrendUp size={13} /> {t.priority}</span>
                </div>
                <div className="text-sm font-medium leading-snug">{t.title}</div>
                <p className="text-xs text-muted-foreground mt-1 line-clamp-2">{t.rationale}</p>
                <div className="flex gap-2 mt-3">
                  <GenerateDialog onStarted={load}
                    initial={{ topic: t.title, universe: t.universe, content_type: t.suggested_type, topic_id: t.id, source_pmids: t.related_pmids }}
                    trigger={<button data-testid={`gen-topic-${t.id}`} className="flex-1 flex items-center justify-center gap-1.5 bg-brand hover:bg-brand-hover text-white py-1.5 rounded-md text-xs font-medium transition-colors">
                      <Sparkle size={13} weight="fill" /> Générer</button>} />
                  <button onClick={() => dismiss(t.id)} className="px-3 border border-border hover:bg-secondary rounded-md text-xs transition-colors">Ignorer</button>
                </div>
              </div>
            ))}
          </div>
        </TabsContent>

        <TabsContent value="studies" className="mt-4">
          <div className="bg-white border border-border rounded-md overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-secondary text-left text-[11px] font-mono uppercase tracking-wider text-muted-foreground">
                <tr><th className="px-4 py-3">Étude</th><th className="px-4 py-3">Revue</th><th className="px-4 py-3 text-center">Pertinence</th><th className="px-4 py-3"></th></tr>
              </thead>
              <tbody className="divide-y divide-border">
                {studies.length === 0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-muted-foreground">Aucune publication suivie.</td></tr>}
                {studies.map((s) => (
                  <tr key={s.id} className="hover:bg-secondary/40 transition-colors">
                    <td className="px-4 py-3 max-w-lg">
                      <div className="font-medium leading-snug">{s.title}</div>
                      <div className="text-xs text-muted-foreground mt-0.5">{s.relevance_reason}</div>
                    </td>
                    <td className="px-4 py-3 text-xs text-muted-foreground">{s.journal}<div>{s.pubdate}</div></td>
                    <td className="px-4 py-3 text-center"><span className="font-mono text-sm font-medium" style={{ color: scoreColor(s.relevance_score) }}>{s.relevance_score}</span></td>
                    <td className="px-4 py-3 text-right"><a href={s.url} target="_blank" rel="noreferrer" className="text-ai hover:text-brand transition-colors inline-flex"><ArrowSquareOut size={16} /></a></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
